module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand1-425e3e67156b688df37682f26aa5af2c.jpg";